var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TaskDetail',{staticClass:"content-block",attrs:{"taskId":_vm.taskId},on:{"done":_vm.onDone,"back":_vm.onBack}})}
var staticRenderFns = []

export { render, staticRenderFns }